// Phone menu: the hamburger toggles the nav links open below the bar; Escape closes it.
class WbNutritionNav extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('.wb-nutrition-site-nav__toggle');
    this.menu = this.querySelector('.wb-nutrition-site-nav__menu');
    if (!this.toggle || !this.menu) return;
    this.onToggle = () => this.setOpen(this.toggle.getAttribute('aria-expanded') !== 'true');
    this.onKey = (event) => {
      if (event.key === 'Escape') this.setOpen(false);
    };
    this.toggle.addEventListener('click', this.onToggle);
    this.addEventListener('keydown', this.onKey);
  }

  disconnectedCallback() {
    this.toggle?.removeEventListener('click', this.onToggle);
    this.removeEventListener('keydown', this.onKey);
  }

  setOpen(open) {
    this.toggle.setAttribute('aria-expanded', String(open));
    this.menu.classList.toggle('is-open', open);
  }
}

if (!customElements.get('wb-nutrition-nav')) customElements.define('wb-nutrition-nav', WbNutritionNav);
